/// <reference path="skyward.base.global.js"/>
/// <reference path="skyward.ui.browse.js"/>
/// <reference path="skyward.ui.modalLayer.js"/>
/// <reference path="skyward.ui.svg.js"/>
/// <reference path="skyward.ui.validation.ts"/>
skyward.base.registerScript('viewOrFilterPopup', function (skyward, $)
{
    "use strict";

    /**
     * @typedef {Object} BrowseParameters Object that defines the parameters needed to describe a Browse for a ViewOrFilterPopup.
     * @property {String} pageModule The backing browse PageModule.
     * @property {String} pageObject The backing browse PageObject.
     * @property {String} pageScreen The backing browse PageScreen.
     * @property {String} browseName The backing browse Name.
     * @property {String} taskName The backing browse TaskName.
     * @property {String} browseId The backing browse ID (HTML ID).
     * @property {String} browseViewEditorHash The backing browse BrowseViewEditorHash (Required for the BrowseViewEditor Page).
     * @property {String} postData The backing browse PostData.
     */

    /**
     * Build a popup to modify BrowseView options or BrowseFilter options.
     * @param {JQuery} button Button that initiated the popup build.  Expected to contain viewOrFilterButtonData.
     * @param {BrowseParameters} browseParameters Object that defines the parameters needed to describe the Browse the popup is attached to.
     */
    function build(button, browseParameters)
    {
        var viewOrFilterButton = button;

        var dialog = buildPopup();
        dialog.content.on('contentLoaded', setupPopup);

        function buildPopup()
        {
            var viewOrFilterButtonData = viewOrFilterButton.data();
            var buildPopupAction = viewOrFilterButtonData.buildPopupAction;
            var title = "Views";

            var cancelButton = { id: "close", text: "Close", click: function () { dialog.close(); }, icon: "Close" };
            var options =
            {
                anchorTo: viewOrFilterButton
            };

            if (browseParameters.browseViewEditorHash)
            {
                buildPopupAction += 'ForBrowseViewEditor';
            }

            var buildPopupFunc = getBuildPopupFunc(browseParameters, buildPopupAction);

            return skyward.modalLayer.showDialog(title, buildPopupFunc, [cancelButton], options);
        }

        function setupPopup()
        {
            var popupContent = $(this);
            var popupData = popupContent.find('#browseFilterOrViewOptions').data();
            var baseErrorsDiv = popupContent.find('#browseViewOrFilterBaseErrors');
            var clickFuncArgs = [popupContent, dialog, popupData.browseId, baseErrorsDiv, browseParameters];

            var isRunning = false;
            var actionDefinitions = [
                { selector: "#resetAndApplyButton", clickFunc: resetAndApply },
                { selector: "#browseViewOrFilterSaveChangesButton", clickFunc: saveChanges },
                { selector: "#browseViewOrFilterSaveAsButton", clickFunc: saveAs },
                { selector: "a.delete", clickFunc: deleteItem },
                { selector: "a.apply.viewOrFilter", clickFunc: apply },
                { selector: "a.reset.viewOrFilter", clickFunc: reset }
            ];

            for (var i = 0; i < actionDefinitions.length; i++)
            {
                var def = actionDefinitions[i];
                popupContent.on("click", def.selector, def, debounce);
            }

            function debounce(event)
            {
                var actionButton = $(this);
                if (actionButton.hasClass('ui-disabled') || actionButton.hasClass('hidden'))
                {
                    return;
                }

                if (!isRunning)
                {
                    isRunning = true;

                    var def = event.data;
                    def.clickFunc.apply(actionButton, clickFuncArgs).always(function ()
                    {
                        isRunning = false;
                    });
                }
            }
        }
    }

    function resetAndApply(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        return menuClosingButtonClick(this, null, dialog, browseId, validationContainer);
    }

    function saveChanges(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var textbox = popupContent.find('#currentNameTextbox');
        var data =
        {
            name: textbox.val(),
            warninghash: JSON.stringify(dialog.content.data("warninghash"))
        };

        if (browseParameters.browseViewEditorHash)
        {
            data.postData = browseParameters.postData;
        }

        return menuClosingButtonClick(this, data, dialog, browseId, validationContainer);
    }

    function saveAs(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var textbox = popupContent.find('.saveAsTextbox');
        var data =
        {
            name: textbox.val()
        };

        return menuClosingButtonClick(this, data, dialog, browseId, validationContainer);
    }

    function deleteItem(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var deleteButton = this;
        var data = deleteButton.data();
        var postData =
        {
            skywardIsDefaultId: data.skywardIsDefaultId,
            browsePrimaryKey: data.browsePrimaryKey
        };

        return menuClosingButtonClick(this, postData, dialog, browseId, validationContainer).always(function ()
        {
            if (deleteButton.hasClass('currentViewOrFilter'))
            {
                if (data)
                {
                    skyward.browse.changeFilter(browseId, { browseFilterId: data.skywardDefaultId });
                }
                else
                {
                    skyward.browse.changeView(browseId, { viewId: data.skywardDefaultId });
                }

                dialog.close();
            }
        });
    }

    function apply(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        const buttonData = this.data();
        let deferred;

        if (buttonData.isFilterRelated)
        {
            deferred = skyward.browse.changeFilter(browseId, { browseFilterId: buttonData.id });
        }
        else
        {
            deferred = skyward.browse.changeView(browseId, { viewId: buttonData.id });
        }

        return deferred.always(function ()
        {
            dialog.close();
        });
    }

    function reset(popupContent, dialog, browseId, validationContainer, browseParameters)
    {
        var button = this;
        var buttonData = button.data();

        return $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/" + buttonData.controller + "/" + buttonData.action + "/" + buttonData.id,
            type: "POST",
            dataType: "JSON",
            activityIndicator: { hideGlass: true },
            success: function (data)
            {
                if (data.success)
                {
                    $(buttonData.modifiedTextRowId).hide();
                    button.css("visibility", "hidden");
                    $(buttonData.applyButtonRowId).data().id = data.id;
                }
                else
                {
                    skyward.validation.displayValidationMessages(data, dialog.content, validationContainer);
                }
            }
        });
    }

    function menuClosingButtonClick(button, postData, dialog, browseId, validationContainer)
    {
        var buttonData = button.data();
        var isFilterRelated = buttonData.isFilterRelated;

        return $.ajax(
        {
            url: skyward.global.virtualDir + "SkySys/" + buttonData.controller + "/" + buttonData.action + "/" + buttonData.id,
            type: "POST",
            dataType: "JSON",
            data: postData,
            activityIndicator: { hideGlass: true },
            success: function (data)
            {
                var disabledControl;

                if (data.success)
                {
                    dialog.close();
                    if (isFilterRelated)
                    {
                        skyward.browse.changeFilter(browseId, { browseFilterId: data.id });
                    }
                    else // isViewRelated
                    {
                        skyward.browse.changeView(browseId, { viewId: data.id });
                    }
                }
                else
                {
                    //ToDo: We have 2 textboxes that display validation for the same field on an object. Ideally we'd like to show validation messages only on the textbox the user
                    // was actually using. Until we get a PR to allow a validation rule to specify a specific control, this is a workaround.
                    if (button.data().disableDuplicateValidation)
                    {
                        disabledControl = disableDuplicateValidation(button);
                    }

                    skyward.validation.displayValidationMessages(data, dialog.content, validationContainer);

                    if (disabledControl !== undefined)
                    {
                        restoreDuplicateValidation(disabledControl);
                    }
                }
            }
        });
    }

    function getBuildPopupFunc(browseParameters, buildPopupAction)
    {
        var data =
        {
            pageScreen: browseParameters.pageScreen,
            browseName: browseParameters.browseName.replace('detailsPanel_', ''),
            taskName: browseParameters.taskName,
            browseId: browseParameters.browseId,
            postData: browseParameters.postData
        };

        return function ()
        {
            return $.ajax(
            {
                url: skyward.global.virtualDir + browseParameters.pageModule + "/" + browseParameters.pageObject + "/" + buildPopupAction,
                type: "POST",
                dataType: "viewparthtml",
                activityIndicator: { hideGlass: true },
                data: data
            });
        };
    }

    function restoreDuplicateValidation(button)
    {
        var data = button.data();

        var validationLabel = $(data.disableOtherHelpLabelValidationId);
        validationLabel.attr('data-validate-message-for', validationLabel.attr('data-original-validate-message-for'));

        var validationTextbox = $(data.disableOtherTextboxValidationId);
        validationTextbox.attr('data-validate-control-for', validationTextbox.attr('data-original-validate-control-for'));
    }

    function disableDuplicateValidation(button)
    {
        var data = button.data();

        var validationLabel = $(data.disableOtherHelpLabelValidationId);
        validationLabel.attr('data-original-validate-message-for', validationLabel.attr('data-validate-message-for'));
        validationLabel.attr('data-validate-message-for', "");

        var validationTextbox = $(data.disableOtherTextboxValidationId);
        validationTextbox.attr('data-original-validate-control-for', validationTextbox.attr('data-validate-control-for'));
        validationTextbox.attr('data-validate-control-for', "");

        return button;
    }

    function buildDefault()
    {
        var viewOrFilterButton = $(this);
        var viewOrFilterButtonData = viewOrFilterButton.data();
        var browseId = viewOrFilterButtonData.browseId;
        var browse = skyward.browse.browseList[browseId];

        var popupBuilderParameters =
        {
            pageModule: browse.pageModule,
            pageObject: browse.pageObject,
            pageScreen: browse.pageScreen,
            browseName: browse.browseName,
            taskName: browse.taskName,
            browseId: browse.id,
            browseViewEditorHash: browse.data.browseViewEditorHash
        };

        if (browse.data.browseViewEditorHash)
        {
            popupBuilderParameters.postData = JSON.stringify(browse.data);
        }

        build(viewOrFilterButton, popupBuilderParameters);
    }

    var events =
    {
        'open': buildDefault
    };

    return events;
});
//# sourceURL=skyward.ui.vieworfilerpopup.js